const capacitor = (
	globalThis as unknown as {
		Capacitor?: {
			isNativePlatform?: () => boolean;
			getPlatform?: () => string;
		};
	}
).Capacitor;

export const isNative: boolean = !!capacitor?.isNativePlatform?.();

// App Review reads a link to the marketing site as a call-to-action towards an
// external purchase mechanism (guideline 3.1.1), so the iOS app must not offer
// any way out of itself. Android and the web keep those links.
export const isIos: boolean = capacitor?.getPlatform?.() === 'ios';

// Web Bluetooth availability (used to gate the "Öffnen"/unlock action).
export const bleAvailable: boolean =
	typeof navigator !== 'undefined' &&
	!!(navigator as Navigator & { bluetooth?: unknown }).bluetooth;

const API_BASE: string = import.meta.env.VITE_API_BASE_URL ?? '';

export function apiUrl(path: string): string {
	return `${isNative ? API_BASE : ''}/api/v1${path}`;
}

export const NATIVE_ALLOWED_PATHS = ['/', '/login'];

export function isAllowedNativePath(pathname: string): boolean {
	if (pathname === '/' || pathname === '/login') return true;
	return pathname.startsWith('/login/');
}
